var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home-cta-container"},[_c('a',{staticClass:"home-cta-button",attrs:{"href":_vm.$t('linkCtaHome'),"rel":"external","target":"_blank","title":_vm.$t('copyCtaHome')}},[_vm._v(_vm._s(_vm.$t("copyCtaHome")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0452fa74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeCta/HomeCta.vue
// module id = null
// module chunks = 